<template>
  <div class="identitySetting">
    <el-container class="el_container">
      <el-aside width="200px" class="el_aside">
        <div class="addRole" @click="addRole">添加身份</div>
        <el-menu
          class="menu"
          popper-class="aside-popper"
          :default-active="defaultActive"
        >
          <el-submenu index="1">
            <template slot="title">自定义身份</template>
            <el-menu-item-group>
              <el-menu-item
                v-for="(item, index) in rolesList.custom"
                :key="index"
                :index="'1-' + index"
                @click="clickRole(item.role_id, 'custom')"
                >{{ item.role_name }}</el-menu-item
              >
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">系统固定身份</template>
            <el-menu-item-group>
              <el-menu-item
                v-for="(item, index) in rolesList.system"
                :key="index"
                :index="'2-' + index"
                @click="clickRole(item.role_id, 'system')"
                >{{ item.role_name }}</el-menu-item
              >
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-container>
        <el-header class="el_header">
          <div>
            {{ roleData.role_name
            }}<span v-if="roleData.staff.total != 0"
              >({{ roleData.staff.total }}人)</span
            >
          </div>
          <div
            class="mwow-button info btnsize"
            @click="clilckrolesDel"
            v-if="type == 'custom'"
            v-debounce="1000"
          >
            删除
          </div>
        </el-header>
        <el-main class="el_main">
          <el-form
            size="mini"
            ref="form"
            label-width="90px"
            :model="formData"
            :rules="rules"
            v-if="showDialog"
          >
            <el-form-item label="身份名称：" prop="name">
              <el-input
                v-model="formData.name"
                placeholder="请输入"
                :disabled="inputbtn"
              ></el-input>
            </el-form-item>
            <el-form-item label="身份描述：">
              <el-input
                type="textarea"
                v-model="formData.describe"
                placeholder="请输入描述"
                :disabled="inputbtn"
              ></el-input>
            </el-form-item>
          </el-form>
          <div
            class="idCardDetails"
            v-if="roleData.staff.name.length > 0 && type != 'add'"
          >
            <div class="idCardDetailsHead">
              角色身份 <span>所有添加了这个身份的员工</span>
            </div>
            <div class="idCardDetailsTabls">
              <div
                v-for="(item, index) in roleData.staff.staff_list"
                :key="index"
              >
                {{ item.name }}
                <span class="tag" v-show="item.status === 2">离职</span>
              </div>
            </div>
          </div>
          <div class="idCardDetails">
            <div class="idCardDetailsHead">
              功能权限 <span>决定用户可以看到的页面以及使用的操作功能</span>
            </div>
            <div class="idCardDetailsCenter">
              <div class="treebox">
                <el-tree
                  :data="roleDataList"
                  show-checkbox
                  :props="defaultProps"
                  :default-checked-keys="checkedKeys"
                  node-key="menu_id"
                  default-expand-all
                  ref="menuTree"
                >
                </el-tree>
              </div>
            </div>
          </div>
          <div class="idCardDetails">
            <div class="idCardDetailsHead">
              数据权限
              <span class="yellow">决定员工可以查看到多少数据或内容</span>
            </div>
            <dataAuthority
              :authorityType="type"
              :authorityData="authorityList"
              @optionChoose="optionChooseData"
            ></dataAuthority>
          </div>
        </el-main>
        <div class="el_footer" v-if="type != 'system'">
          <div
            class="mwow-button-filled success btnsize"
            @click="clickKeep"
            v-debounce="1000"
          >
            {{ type == "add" ? "保 存" : "确认修改" }}
          </div>
        </div>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import dataAuthority from "./dataAuthority.vue";
import {
  rolesList,
  rolesMenu,
  rolesCreate,
  rolesModify,
  rolesDetail,
  rolesDel,
} from "@/api/setTing";
export default {
  props: ["types", "visible"],
  components: {
    dataAuthority,
  },
  data() {
    return {
      rolesList: [],
      roleData: {
        staff: { total: 0, name: [], staff_list: [] },
      },
      formData: {
        name: "",
        describe: "",
      },
      defaultActive: "", //设置左边菜单选中
      defaultProps: {
        children: "children",
        label: "name",
      }, //定义选中盒子的字段
      checkedKeys: [], //选中的盒子
      checkChange: [], //点击选中的数据
      roleDataList: [],
      role_id: 0,
      type: "",
      rules: {
        name: [{ required: true, message: "请输入名字", trigger: "blur" }],
      },
      inputbtn: false,
      showDialog: false,
      authorityList: [],
      optionChooseDatas: [],
    };
  },
  created() {
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.init();
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.init();
    }
  },
  methods: {
    init() {
      const _t = this;
      if (_t.types != "") {
        _t.type = _t.types;
        _t.getrolesMenu();
        _t.showDialog = true;
        rolesList().then((res) => {
          if (res.error_code == 0) {
            _t.rolesList = res.data;
          }
        });
      } else {
        _t.getList(() => {});
      }
    },
    getList(cb) {
      const _t = this;
      rolesList().then((res) => {
        if (res.error_code == 0) {
          let id = 0;
          let type = "";
          _t.rolesList = res.data;
          if (res.data.custom.length == 0) {
            _t.defaultActive = "2-0";
            id = res.data.system[0].role_id;
            type = "system";
          } else {
            _t.defaultActive = "1-0";
            id = res.data.custom[0].role_id;
            type = "custom";
          }
          _t.type = type;
          if (id != 0) {
            _t.clickRole(id, type);
          }
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
        if (cb) {
          cb();
        }
      });
    },
    clilckrolesDel() {
      const _t = this;
      _t.$confirm(
        `所有包含“${_t.roleData.role_name}”身份员工都将失去对应的权限，此操作不可撤销。`,
        `删除 - 身份设置`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          iconClass: "mwow-icon-error",
        }
      )
        .then(() => {
          rolesDel({ role_id: _t.role_id }).then((res) => {
            if (res.error_code == 0) {
              _t.defaultActive = "";
              _t.getList(() => {});
              _t.$message({
                type: "success",
                message: "删除成功",
              });
            } else {
              _t.$message({
                type: "error",
                message: res.message,
              });
            }
          });
        })
        .catch(() => {});
    },
    getrolesMenu() {
      const _t = this;
      rolesMenu().then((res) => {
        if (res.error_code == 0) {
          // res.data.list.map((a:any,b:number)=>{
          //   res.data.list[b]=[];
          //   res.data.list[b].push(a);
          // })
          // _t.checkedKeys = [];
          _t.roleDataList = [];
          _t.roleData.role_name = "自定义身份";
          _t.roleData.staff.total = 0;
          _t.roleDataList = res.data.list;
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    clickKeep() {
      const _t = this;
      _t.$refs["form"].validate((valid) => {
        if (valid) {
          const arry = [];
          const checkArr = _t.$refs.menuTree.getCheckedNodes(false, true);
          checkArr.map((a) => {
            arry.push(a.menu_id);
          });
          if (arry.length == 0) {
            _t.$message({
              type: "error",
              message: "功能权限未勾选",
            });
            return;
          }
          if (_t.type == "add") {
            _t.postRolesCreate({
              menu_rules: arry,
              data_authority: _t.optionChooseDatas,
            });
          } else if (_t.type == "custom") {
            _t.postrolesModify({
              menu_rules: arry,
              role_id: _t.role_id,
              data_authority: _t.optionChooseDatas,
            });
          }
        } else {
          return false;
        }
      });
    },
    postrolesModify(data) {
      const _t = this;
      if (_t.formData.name != "") {
        data.role_name = _t.formData.name;
      }
      if (_t.formData.describe != "") {
        data.describe = _t.formData.describe;
      }
      rolesModify(data).then((res) => {
        if (res.error_code == 0) {
          _t.getList(() => {});
          _t.$message({
            type: "success",
            message: "编辑成功!",
          });
          const content = document.querySelector(".layout-content");
          content.scrollTop = 0;
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    postRolesCreate(data) {
      const _t = this;
      if (_t.formData.name != "") {
        data.role_name = _t.formData.name;
      }
      if (_t.formData.describe != "") {
        data.describe = _t.formData.describe;
      }
      rolesCreate(data).then((res) => {
        if (res.error_code == 0) {
          _t.getList(() => {});
          _t.$message({
            type: "success",
            message: "添加成功!",
          });
          const content = document.querySelector(".layout-content");
          content.scrollTop = 0;
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    clickRole(e, type) {
      const _t = this;
      _t.role_id = e;
      _t.type = type;
      _t.showDialog = false;
      if (type == "system") {
        _t.inputbtn = true;
      } else {
        _t.inputbtn = false;
      }
      rolesDetail({ role_id: e }).then((res) => {
        if (res.error_code == 0) {
          _t.showDialog = true;
          _t.checkedKeys.length = 0;
          _t.itemGetid(res.data.menu, type);
          // res.data.menu.map((a:any,b:number)=>{
          //   res.data.menu[b]=[];
          //   res.data.menu[b].push(a);
          // })
          _t.roleData = res.data;
          _t.roleDataList = res.data.menu;
          const obj = _t.formData;
          obj.name = res.data.role_name;
          _t.formData = obj;
          obj.describe = res.data.describe;
          _t.authorityList = res.data.data_authority;
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    itemGetid(itemData, type) {
      const _t = this;
      itemData.map((item) => {
        if (item.is_select) {
          if (item.children == null) {
            _t.checkedKeys.push(item.menu_id);
          } else {
            _t.itemGetid(item.children, type);
          }
        }
        if (type == "system") {
          item.disabled = true;
          if (item.children != null) {
            _t.itemGetid(item.children, type);
          }
        }
      });
    },
    optionChooseData(e) {
      this.optionChooseDatas = e;
    },
    addRole() {
      const _t = this;
      _t.type = "add";
      _t.formData.name = "";
      _t.formData.describe = "";
      _t.defaultActive = "";
      _t.checkedKeys.length = 0;
      _t.inputbtn = false;
      _t.getrolesMenu();
    },
  },
};
</script>

<style scoped lang="scss">
.identitySetting {
  .el_container {
    min-height: 83vh;
    overflow-y: auto;
    .el_aside {
      border-right: 1px solid #eee;
      padding: 12px;
    }
    /deep/ .el-menu-item-group {
      padding-bottom: 8px;
    }
    /deep/ .menu {
      border-right: none !important;
      .el-submenu {
        border-bottom: 1px solid #e7e8ea;
      }
      .el-submenu:last-child {
        border: 0;
      }
      .el-menu-item {
        line-height: 40px;
        height: 40px;
        font-size: 12px;
        color: #303133;
        position: relative;
        &.is-active {
          background-color: #f0fdfa;
          color: #07d1aa;
          &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            color: #07d1aa;
          }
        }
        &:hover {
          background-color: #f0fdfa;
        }
      }
      .el-submenu {
        .el-menu-item {
          min-width: 0;
          &.is-active {
            &::after {
              background-color: #07d1aa;
            }
          }
        }
        .el-submenu__title {
          line-height: 40px;
          height: 40px;
          font-size: 14px;
          color: #303133;
          font-weight: bold;
          &:hover {
            background-color: #f0fdfa;
          }
        }
      }
      i {
        font-size: 16px;
      }
    }
    .el_header {
      height: 40px !important;
      line-height: 40px;
      font-size: 14px;
      color: #5c5d5e;
      font-weight: bold;
      display: flex;
      justify-content: space-between;
      .btnsize {
        height: 25px;
        line-height: 25px !important;
      }
      span {
        margin-left: 8px;
        color: #07d1aa;
        font-size: 12px;
        font-weight: none;
      }
    }
  }
  .addRole {
    width: 120px;
    height: 28px;
    opacity: 1;
    background: #ffffff;
    border: 1px solid #07d1aa;
    text-align: center;
    line-height: 28px;
    border-radius: 4px;
    color: #07d1aa;
    margin: 0 auto;
    margin-bottom: 10px;
    font-size: 12px;
    cursor: pointer;
  }
  .idCardDetails {
    padding: 10px 20px;
    width: 96%;
    border: 1px solid #d9dadb;
    border-radius: 4px;
    margin-bottom: 20px;
    font-size: 12px;
    .idCardDetailsTabls {
      display: flex;
      flex-wrap: wrap;
      div {
        padding: 7px 15px;
        font-size: 12px;
        color: #5c5d5e;
        background: #f6fafc;
        margin-right: 10px;
        margin-top: 10px;
        .tag {
          font-size: 12px;
          line-height: 12px;
          padding: 2px 4px;
          border-radius: 2px;
          color: #f56c6c;
          border: 1px solid #f56c6c;
          margin-left: 6px;
        }
      }
    }
    /deep/ .el-checkbox {
      margin-right: 20px;
    }
    .idCardDetailsHead {
      font-size: 14px;
      font-weight: bold;
      line-height: 28px;
      span {
        color: #07d1aa;
        font-size: 12px;
        margin-left: 20px;
        font-weight: normal;
      }
    }
    .idCardDetailsCenter {
      padding: 20px 10px;
      display: flex;
      .treebox {
        margin-right: 20px;
        margin-bottom: 10px;
        min-height: 150px;
      }
    }
    .idCardDetailsCenter:last-child {
      border: 0;
    }
    .chooseTiele {
      color: #5c5d5e;
      width: 80px;
      line-height: normal;
      font-weight: bold;
    }
    .choose_Details {
      .chooseChooseSon {
        padding-left: 25px;
      }
    }
  }
  .el_main {
    .el-input {
      width: 240px;
    }
    .el-textarea {
      width: 544px;
      min-height: 68px;
    }
  }
  .el_footer {
    display: flex;
    .btnsize {
      padding: 0 11px;
      line-height: 28px !important;
      margin-left: 10px;
    }
  }
  //数据权限
  .authorityChooseBox {
    display: flex;
    .authorityChooseBoxSm {
      .authorTitle {
        color: #5c5d5e;
        font-size: 12px;
        font-weight: bold;
      }
      .chooseOption {
        margin-top: 12px;
        font-size: 12px;
        /deep/ .el-radio__label {
          font-size: 12px !important;
        }
      }
    }
  }
  //end数据权限
  /deep/ .el-tree-node.is-expanded > .el-tree-node__children {
    display: flex;
    flex-wrap: wrap; // flex横向布局换行显示
  }
  /deep/ .collapse-transition {
    transition: none !important;
  }
  .yellow {
    color: #ffb940 !important;
  }
  .gray {
    color: #a4a5a5 !important;
  }
}
</style>
